module.exports = __webpack_public_path__ + "68e4e62b2c84aefda32251e20df8d5a1.svg";